export enum OrganizationType {
  INSURANCE = "INSURANCE",
  ORGANIZATION = "ORGANIZATION",
  SOCIAL_SECURITY = "SOCIAL_SECURITY",
}
